export default "__VITE_ASSET__Dvqfj9W2__"